import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import {
  getCloudflareImageUrl,
  getStaticUrl,
} from '@/hooks/useCloudflareImage';

export const Container = styled('div')`
  height: 100%;
  color: ${({ theme }) => theme.color.darkGray};

  background: url(${getCloudflareImageUrl({
    src: getStaticUrl('/onboarding/background-desktop-2x.png'),
    width: 316,
    height: 302,
  })})
  no-repeat right bottom,
  linear-gradient(
    180deg,
    rgba(35, 148, 223, 0.3) 0%,
    rgba(35, 148, 223, 0.1) 100%
  )
  fixed;

  ${media.mdDown`
    background: url(${getCloudflareImageUrl({
      src: getStaticUrl('/onboarding/background-mobile-2x.png'),
      width: 181,
      height: 229,
    })})
      no-repeat right bottom,
    linear-gradient(
        180deg,
        rgba(35, 148, 223, 0.3) 0%,
        rgba(35, 148, 223, 0.1) 100%
      )
      fixed;
  `}

  @media (max-width: 320px) {
  background: url(''),
  background: linear-gradient(
    180deg,
    rgba(35, 148, 223, 0.3) 0%,
    rgba(35, 148, 223, 0.1) 100%
  );
  fixed;
}
`;
